'use client';

import { useKeepAlive } from '@/hooks/useKeepAlive';

export default function KeepAliveProvider() {
  useKeepAlive();
  return null;
}
